import captureException from './captureException';

const isChunkLoaderError = (err: unknown) => err instanceof Error && err.name === 'ChunkLoadError';

/**
 * Helper function to retry dynamic imports in case of network failure.
 */
const dynamicImport = (
  loader: () => Promise<any>,
  fallback: () => any | Promise<any> = () => { },
): Promise<any> => {
  let importAttempt = 1;
  // Assume a network failure and and attempt to reload the import.
  const retry = (err: unknown) => {
    if (isChunkLoaderError(err)) {
      captureException(err, {
        extra: {
          importAttempt,
        },
      });
      importAttempt += 1;
      return loader();
    }
    // This is not the error we're trying to cater for, so propagate it.
    throw err;
  };

  return loader()
    .catch(retry)
    .catch(retry)
    .catch((err) => {
      captureException(err, {
        extra: {
          importAttempt: isChunkLoaderError(err) ? importAttempt : null,
        },
      });

      return fallback;
    });
};

export default dynamicImport;
